import { useTrackedSessionStorage } from "@/hooks/use-tracked-browser-storage";
import { CUSTOM_CHANNELS_RULESET_STORAGE_KEY } from "@/pages/custom-channels/custom-channels-list/custom-channels-ruleset-selector";

/**
 * Hook to access the currently selected custom channels ruleset id.
 *
 * The selection is stored in org-scoped sessionStorage and is:
 * - Tab-scoped (each tab has its own selection)
 * - Not persisted across sessions
 * - Synced between custom channels list and report card views
 * - Sent to the backend on Custom Channels API requests
 *
 * @returns The selected ruleset id (or null if none selected)
 */
export function useSelectedRulesetId(): string | null {
  const [selectedRuleSetId] = useTrackedSessionStorage<string | null>(
    CUSTOM_CHANNELS_RULESET_STORAGE_KEY,
    null,
    {
      migration: {
        from: {
          key: "custom-channels::list::selected-ruleset-id",
          storage: "localStorage",
          organizationScoped: true,
        },
        cleanup: true,
      },
    },
  );

  return selectedRuleSetId;
}
